<template>
    <div id="app">
        <v-app id="inspire">
            <v-card v-model="show" color="#FFFF99">
                <v-card-title>
                    <v-icon large left>mdi-wrench-clock</v-icon>
                    <h6>Control de Documentos de Ingeniería</h6>

                </v-card-title>
                <v-card-text>
                    <v-row dense>
                        <v-col cols="12" md="4" sm="6">
                            <v-select dense outlined :items="listadoestado" item-text="texto" item-value="valor"
                                label="Filtrar por estado:" v-model="estado" clearable hide-details="auto"
                                class="font-class-name" />
                        </v-col>
                        <v-col cols="12" md="4" sm="6">
                            <v-select dense outlined :items="clientes" item-text="cliente" return-object
                                label="Filtrar por Cliente" clearable v-model="cliente" hide-details="auto"
                                class="font-class-name" />
                        </v-col>
                        <v-col cols="12" md="4" sm="6">
                            <v-select dense outlined :items="obras" item-text="obra" item-value="obra"
                                label="Filtrar por Obra" return-object clearable v-model="obra" hide-details="auto"
                                class="font-class-name" />
                        </v-col>
                    </v-row>
                    <v-row dense>
                        <v-col cols="12" md="4">
                            <v-btn color="green" dark @click="cargar()" max-width="200">
                                Nuevo remito
                            </v-btn>
                        </v-col>
                        <v-col cols="12" md="4">
                            <v-btn color="blue" dark @click="ver()" depressed max-width="220">
                                Estado de Documentos
                            </v-btn>
                        </v-col>
                        <v-col cols="12" md="4">
                            <v-btn color="orange" dark @click="editar()" depressed max-width="200">
                                Recuperar Remito
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
            <v-card>
                <v-card-text>
                    <v-data-table dense :headers="headers" :items="listadoFiltrado" :single-expand="true" locale="es-ar"
                        class="elevation-1" :items-per-page="200000" hide-default-footer :loading="loadtable"
                        loading-text="Cargando... Espere por favor" no-data-text="No hay datos disponibles">

                        <template v-slot:item.estadoenviado="{ item }">
                            <div v-if="item.estado == 'E'">
                                X
                            </div>
                        </template>
                        <template v-slot:item.estadorecibido="{ item }">
                            <div v-if="item.estado == 'R'">
                                X
                            </div>
                        </template>
                        <template v-slot:item.checkcliente="{ item }">
                            <div v-if="item.checkcliente == 'ON'">
                                X
                            </div>
                        </template>
                        <template v-slot:item.checkjefe="{ item }">
                            <div v-if="item.checkjefe == 'ON'">
                                X
                            </div>
                        </template>
                        <template v-slot:item.checksubcont="{ item }">
                            <div v-if="item.checksubcont == 'ON'">
                                X
                            </div>
                        </template>
                        <template v-slot:item.actions="{ item }">
                            <v-tooltip top>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-icon small color="red" class="mr-2" @click="borrar(item)">
                                        mdi-delete
                                    </v-icon>
                                </template>
                                <span>Borrar</span>
                            </v-tooltip>
                        </template>
                        <template v-slot:item.imprimir="{ item }">
                            <v-tooltip top>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-icon small color="blue" v-on="on" v-bind="attrs" @click="imprimirRemito(item)">
                                        mdi-printer
                                    </v-icon>
                                </template>
                                <span>Imprimir Remito</span>
                            </v-tooltip>
                        </template>
                    </v-data-table>
                </v-card-text>
            </v-card>
            <Cargar :visible="showCargar" @close="showCargar = false">
            </Cargar>
            <Ver :visible="showVer" :numcliente="numcliente" :numobra="numobra" :cliente="nomcliente" :obra="nomobra"
                @close="showVer = false"></Ver>
            <Editar :visible="showEditar" @close="showEditar = false">
            </Editar>

            <!-- Dialog Imprimir Remito -->
            <v-dialog v-model="showImprimir" fullscreen hide-overlay transition="dialog-bottom-transition">
                <v-card>
                    <v-toolbar dense dark color="blue darken-2" class="no-print">
                        <v-btn icon @click="showImprimir = false"><v-icon>mdi-close</v-icon></v-btn>
                        <v-toolbar-title class="text-body-2">Vista Previa — Remito N° rD-{{ remitoImprimir.remito }}</v-toolbar-title>
                        <v-spacer />
                        <v-btn small color="success" @click="print">
                            <v-icon left small>mdi-printer</v-icon>Imprimir / PDF
                        </v-btn>
                    </v-toolbar>

                    <div id="printArea" class="print-area pa-6">
                        <div v-if="remitoImprimir.remito">
                            <!-- Encabezado -->
                            <table style="width: 100%; border-collapse: collapse; margin-bottom: 12px;">
                                <tr>
                                    <td style="width: 20%; vertical-align: top;">
                                        <img src="logo_footer.svg" style="max-height: 50px;" />
                                    </td>
                                    <td style="width: 60%; text-align: center; vertical-align: middle;">
                                        <div style="font-size: 16px; font-weight: 700;">CONTROL DE DOCUMENTOS DE INGENIERÍA</div>
                                        <div style="font-size: 12px; color: #555;">Remito de Entrega / Recepción de Documentación</div>
                                    </td>
                                    <td style="width: 20%; text-align: right; vertical-align: top;">
                                        <div style="font-size: 14px; font-weight: 700; color: #1e3f7a;">Remito N° rD-{{ remitoImprimir.remito }}</div>
                                        <div style="font-size: 11px;">Fecha: {{ remitoImprimir.fecha }}</div>
                                    </td>
                                </tr>
                            </table>

                            <!-- Datos -->
                            <table style="width: 100%; border: 1px solid #333; border-collapse: collapse; font-size: 11px; margin-bottom: 10px;">
                                <tr>
                                    <td style="border: 1px solid #333; padding: 4px 8px; font-weight: 600; width: 15%;">Cliente:</td>
                                    <td style="border: 1px solid #333; padding: 4px 8px; width: 35%;">{{ remitoImprimir.numcliente }} - {{ remitoImprimir.nomcliente }}</td>
                                    <td style="border: 1px solid #333; padding: 4px 8px; font-weight: 600; width: 15%;">Obra:</td>
                                    <td style="border: 1px solid #333; padding: 4px 8px; width: 35%;">{{ remitoImprimir.numobra }} - {{ remitoImprimir.nomobra }}</td>
                                </tr>
                                <tr>
                                    <td style="border: 1px solid #333; padding: 4px 8px; font-weight: 600;">Responsable:</td>
                                    <td style="border: 1px solid #333; padding: 4px 8px;">{{ remitoImprimir.responsable }}</td>
                                    <td style="border: 1px solid #333; padding: 4px 8px; font-weight: 600;">Estado:</td>
                                    <td style="border: 1px solid #333; padding: 4px 8px;">{{ remitoImprimir.estado === 'E' ? 'Envío' : 'Recepción' }}</td>
                                </tr>
                            </table>

                            <!-- Destinatarios -->
                            <table style="width: 100%; border: 1px solid #333; border-collapse: collapse; font-size: 11px; margin-bottom: 10px;">
                                <thead>
                                    <tr style="background: #eee;">
                                        <th style="border: 1px solid #333; padding: 4px;">Destinatario</th>
                                        <th style="border: 1px solid #333; padding: 4px; width: 60px;">Copias</th>
                                        <th style="border: 1px solid #333; padding: 4px; width: 60px;">e-Mail</th>
                                        <th style="border: 1px solid #333; padding: 4px;">Recibió</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-if="remitoImprimir.checkcliente === 'ON'">
                                        <td style="border: 1px solid #333; padding: 4px;">Cliente</td>
                                        <td style="border: 1px solid #333; padding: 4px; text-align: center;">{{ remitoImprimir.copiacliente }}</td>
                                        <td style="border: 1px solid #333; padding: 4px; text-align: center;">{{ remitoImprimir.mailcliente === 'ON' ? '✓' : '' }}</td>
                                        <td style="border: 1px solid #333; padding: 4px;">{{ remitoImprimir.recibiocliente }}</td>
                                    </tr>
                                    <tr v-if="remitoImprimir.checkjefe === 'ON'">
                                        <td style="border: 1px solid #333; padding: 4px;">Jefe de Obra / Resp. Fabricación</td>
                                        <td style="border: 1px solid #333; padding: 4px; text-align: center;">{{ remitoImprimir.copiajefe }}</td>
                                        <td style="border: 1px solid #333; padding: 4px; text-align: center;">{{ remitoImprimir.mailjefe === 'ON' ? '✓' : '' }}</td>
                                        <td style="border: 1px solid #333; padding: 4px;">{{ remitoImprimir.recibiojefe }}</td>
                                    </tr>
                                    <tr v-if="remitoImprimir.checksubcont === 'ON'">
                                        <td style="border: 1px solid #333; padding: 4px;">Subcontratista</td>
                                        <td style="border: 1px solid #333; padding: 4px; text-align: center;">{{ remitoImprimir.copiasubcont }}</td>
                                        <td style="border: 1px solid #333; padding: 4px; text-align: center;">{{ remitoImprimir.mailsubcont === 'ON' ? '✓' : '' }}</td>
                                        <td style="border: 1px solid #333; padding: 4px;">{{ remitoImprimir.recibiosubcont }}</td>
                                    </tr>
                                </tbody>
                            </table>

                            <!-- Detalle de documentos -->
                            <table style="width: 100%; border: 1px solid #333; border-collapse: collapse; font-size: 10px;">
                                <thead>
                                    <tr style="background: #1e3f7a; color: white;">
                                        <th style="border: 1px solid #333; padding: 4px;">N°</th>
                                        <th style="border: 1px solid #333; padding: 4px;">Nombre</th>
                                        <th style="border: 1px solid #333; padding: 4px;">Revisión</th>
                                        <th style="border: 1px solid #333; padding: 4px;">Descripción</th>
                                        <th style="border: 1px solid #333; padding: 4px;">Tipo</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(doc, idx) in remitoDetalle" :key="idx">
                                        <td style="border: 1px solid #333; padding: 3px 6px; text-align: center;">{{ idx + 1 }}</td>
                                        <td style="border: 1px solid #333; padding: 3px 6px;">{{ doc.nomplano }}</td>
                                        <td style="border: 1px solid #333; padding: 3px 6px; text-align: center;">{{ doc.revision }}</td>
                                        <td style="border: 1px solid #333; padding: 3px 6px;">{{ doc.descrplano }}</td>
                                        <td style="border: 1px solid #333; padding: 3px 6px; text-align: center;">{{ doc.tipoarchivo }}</td>
                                    </tr>
                                </tbody>
                            </table>

                            <!-- Pie -->
                            <div style="margin-top: 20px; font-size: 10px; display: flex; justify-content: space-between;">
                                <div>Total documentos: {{ remitoImprimir.ndocumentos }}</div>
                                <div>ICSSA — Control de Documentos de Ingeniería</div>
                            </div>
                        </div>
                    </div>
                </v-card>
            </v-dialog>
        </v-app>
    </div>

</template>

<style scoped>
.font-class-name2 {
    font-size: 12px !important;
}

::v-deep .v-data-table .v-data-table__wrapper td {
    font-size: 12px !important;
    padding: 2px 4px !important;
}

::v-deep .v-data-table .v-data-table-header tr th {
    font-size: 12px !important;
    padding: 2px 4px !important;
}

.celda-color {
    width: 100%;
    height: 100%;
    padding: 4px 8px;
    box-sizing: border-box;
}

.print-area {
    background: white;
    color: #111;
}

@media print {
    .no-print,
    .v-toolbar,
    .v-card:not(:has(.print-area)),
    .v-app-bar {
        display: none !important;
    }
    .v-dialog__content {
        position: static !important;
    }
    .v-dialog {
        box-shadow: none !important;
        margin: 0 !important;
        max-height: none !important;
        overflow: visible !important;
    }
    .print-area {
        padding: 10mm !important;
    }
    @page {
        size: A4 portrait;
        margin: 8mm;
    }
}
</style>
<script>
import axios from "../../../axios-auth";
import Cargar from "../Documentos/Nuevoremito.vue"
import Ver from "../Documentos/Estadodoc.vue"
import Editar from "../Documentos/Recuperarremito.vue"
import moment from "moment";

export default {
    components: { Cargar, Ver, Editar },
    data: (vm) => ({
        usuario: "",
        editedItem: {
            fact: "",
            codgral: "",
            empresa: "",
            codoc: "",
            responsable: "",
        },
        editedIndex: -1,
        estado: "",
        listadoestado: [{ texto: "Todos", valor: "" },
        { texto: "Solo enviados", valor: "E" },
        { texto: "Solo recibidos", valor: "R" },],
        cliente: null,
        clientes: [],
        numcliente: "",
        numobra: "",
        nomcliente: "",
        nomobra: "",
        obra: null,
        obras: [],
        listado: [],
        loadtable: false,
        headers: [
            {
                text: "N° Remito",
                align: "start",
                sortable: false,
                value: "remito",
            },
            { text: "N° Cliente", value: "numcliente", sortable: false },
            { text: "Cliente", value: "nomcliente", sortable: false },
            { text: "N° Obra", value: "numobra", sortable: false },
            { text: "Obra", value: "nomobra", sortable: false },
            { text: "Fecha", value: "fecha", sortable: false },
            { text: "Responsable", value: "responsable", sortable: false },
            { text: "Cantidad", value: "ndocumentos", sortable: false },
            { text: "Enviado", value: "estadoenviado", sortable: false },
            { text: "Recibido", value: "estadorecibido", sortable: false },
            { text: "Cli.", value: "checkcliente", sortable: false },
            { text: "J.O./R.F.", value: "checkjefe", sortable: false },
            { text: "Sub.", value: "checksubcont", sortable: false },
            { text: "Borrar", value: "actions", sortable: false },
            { text: "Imprimir", value: "imprimir", sortable: false },

        ],
        showCargar: false,
        showVer: false,
        showEditar: false,
        showImprimir: false,
        remitoImprimir: {},
        remitoDetalle: [],
    }),
    watch: {
        cliente(val) {

            if (!val) {
                this.obra = null;
                this.obras = [];
                return;
            }
            this.numcliente = this.cliente.numcliente;
            this.listadoobras();
        },
    },

    computed: {
        show: {
            get() {
                this.cargarListados();
                this.listadoclientes();
            },
            set(value) {
                if (!value) {
                    this.vaciarModels();
                    this.$emit("close");
                }
            },
        },

        listadoFiltrado() {
            return this.listado.filter(item => {

                // =====================
                // FILTRO POR CLIENTE
                // =====================

                if (!this.cliente && !this.obra) return true;

                if (this.cliente && this.cliente.numcliente) {
                    if (item.numcliente !== this.cliente.numcliente) {
                        return false;
                    }
                }

                // =====================
                // FILTRO POR OBRA
                // =====================
                if (this.obra && this.obra.numobra) {
                    if (item.numobra !== this.obra.numobra) {
                        return false;
                    }
                }

                /* =====================
                   FILTRO POR ESTADO
                ====================== */
                if (!this.estado) return true;

                const estado = item.estado;

                switch (this.estado) {

                    case "E":
                        return estado === "E";

                    case "R":
                        return estado === "R";

                    default:
                        return true;
                }
            });
        }

    },

    methods: {
        text_color(item) {
            if (item.estado == "ENV") {
                return "#0000FF";
            }
            if (item.estado == "OBS") {
                return "#FF0000";
            }
            if (item.estado == "AcO") {
                return "#800080";
            }
            if (item.estado == "APR") {
                return "#008000";
            }
            else {
                return "#000000";
            }
        },

        row_color(item) {

            if (item.tipoplano == "E") {
                return "#FFCC99";
            }
            if (item.tipoplano == "C") {
                return "#FFFF99";
            }
            if (item.tipoplano == "M") {
                return "#99FF66";
            }
            if (item.tipoplano == "B") {
                return "#CC99FF";
            }
            if (item.tipoplano == "D") {
                return "#99FFCC";
            }
            if (item.tipoplano == "T") {
                return "#99CCFF";
            }
            if (item.tipoplano == "P") {
                return "#FF99FF";
            }
            if (item.tipoplano == "F") {
                return "#FFFF66";
            }
            if (item.tipoplano == "N") {
                return "#9999FF";
            }
            if (item.tipoplano == "X") {
                return "#FF9933";
            }
            if (item.tipoplano == "O") {
                return "#CCCCCC";
            }
            if (item.tipoplano == "AI") {
                return "#99FF99";
            }
            if (item.tipoplano == "PR") {
                return "#CCFF66";
            }
            if (item.tipoplano == "PT") {
                return "#CCFF66";
            }
            if (item.tipoplano == "A") {
                return "#CCCCFF";
            }
        },

        listadoclientes() {
            let self = this;
            axios
                .get("/Ingenieria/Listadoclientes?", {
                    params: {
                        filtrocliente: '',
                    },
                })
                .then((response) => {
                    self.clientes = response.data;
                })
                .catch((error) => {
                    self.clientes = [];
                    console.log(error);
                });
        },
        listadoobras() {
            //this.obras = [];
            console.log("ENTRO a obras")
            let self = this;
            axios
                .get("/Ingenieria/Listadoobras?", {
                    params: {
                        filtroobra: '',
                        filtrocliente: self.numcliente,
                    },
                })
                .then((response) => {
                    self.obras = response.data;
                })
                .catch((error) => {
                    self.obras = [];
                    console.log(error);
                });
        },
        cargarListados() {
            this.loadtable = true;
            let self = this;
            axios
                .get("/Ingenieria/RemitoListado?", {
                    params: {
                        numobra: self.obra?.numobra || '',
                        numcliente: self.cliente?.numcliente || '',
                    },
                })
                .then((response) => {
                    self.listado = response.data;
                    self.loadtable = false;
                    console.log("listado remitos ", self.listado)
                })
                .catch((error) => {
                    self.listado = [];
                    console.log(error);
                });

        },

        vaciarModels() {
            this.listado = [];

        },

        cargar(item) {
            this.showCargar = true;
        },
        editar(item) {
            this.showEditar = true;
        },
        ver(item) {
            if (this.obra == null) {
                this.showAlert({
                    icon: "warning",
                    title: "Debe elegir un cliente y una obra",
                    vm: this,
                });
            }
            else {
                this.numcliente = this.cliente.numcliente;
                this.numobra = this.obra.numobra;
                this.nomcliente = this.cliente.nomcliente;
                this.nomobra = this.obra.nomobra;
                this.showVer = true;
            }
        },

        showAlert(alertInfo) {
            alertInfo.vm.$swal.fire({
                icon: alertInfo.icon,
                title: alertInfo.title,
                showConfirmButton: false,
                background: "#ececec",
                timer: 3000,
            });
        },

        borrar(item) {
            this.$swal({
                title: "¿Eliminar remito?",
                text: `Remito N° rD-${item.remito} — ${item.nomcliente || ''} / ${item.nomobra || ''}`,
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: "Sí, eliminar",
                cancelButtonText: "No",
                confirmButtonColor: "#e5383b",
            }).then((result) => {
                if (result.value) {
                    axios
                        .delete("/Ingenieria/EliminarRemito", { params: { remito: item.remito } })
                        .then(() => {
                            this.showAlert({ icon: "success", title: "Remito eliminado", vm: this });
                            this.cargarListados();
                        })
                        .catch(() => {
                            this.showAlert({ icon: "error", title: "Error al eliminar el remito", vm: this });
                        });
                }
            });
        },

        imprimirRemito(item) {
            this.remitoImprimir = item;
            // Cargar detalle del remito (documentos)
            axios
                .get("/Ingenieria/ObtenerDetalleRemito", {
                    params: { remito: item.remito },
                })
                .then((response) => {
                    this.remitoDetalle = response.data || [];
                    this.showImprimir = true;
                })
                .catch(() => {
                    this.remitoDetalle = [];
                    this.showImprimir = true;
                });
        },

        print() {
            window.print();
        },
    },
};
</script>
